export const DESKTOP_ROUTES = {
    LANDING: 'landing'
};
